import Connector from '../../agent';
import { AxiosError, AxiosResponse } from 'axios';
import { InventoryShortDTO } from './dto/InventoryShortDTO';

const GET_INVENTORY_SHORT_ENDPOINT = 'inventories/short/';

function safeQueryHandler(safeQuery: any) {
  return safeQuery
    .then((response: { data: JSON }) => {
      return { inventory: (response as AxiosResponse).data };
    })
    .catch((error: AxiosError) => {
      const enc = new TextDecoder('utf-8');
      const err = error as AxiosError;
      throw new Error(enc.decode(err.response?.data as BufferSource));
    });
}

function getInventorySimplified(endpoint: string) {
  const safeQuery = Connector.api._safeQuery(
    Connector.api._axios.get,
    endpoint,
    null,
    null,
    false,
    false
  );

  return safeQueryHandler(safeQuery);
}

export function getInventoryShort(inventoryId: number) {
  return getInventorySimplified(`${GET_INVENTORY_SHORT_ENDPOINT}${inventoryId}`);
}
